export enum vuaIdSuffix {
  value = "@ink",
}
